
jQuery(document).ready(function ($) {

    /*
      Handling Invalid field in forms.
    
      var wpcf7Elm = document.querySelector( '.wpcf7' );
  
      wpcf7Elm.addEventListener( 'wpcf7invalid',
      function(event) {
          setTimeout(onInvalidFormInput ,0, event );
      });*/

    $('.wpcf7').on('wpcf7invalid', function (event) {

        //console.log("wpcf7invalid event")

        setTimeout(onInvalidFormInput, 0, event);
    });

    $('.wpcf7').on('wpcf7mailsent', function (event) {

        //console.log("wpcf7mailsent event")
        setTimeout(onFormSubmit, 0, event);

    });


    function onFormSubmit(event) {
        var theForm = event.target;
        /*var formId =  $(theForm).parent().attr("id") ;*/

        $(theForm).find('label').removeClass("invalid");

    }

    function onInvalidFormInput(event) {

        var theForm = event.target;
        var formId = $(theForm).parent().attr("id");

        // screen-reader-response make visibble:
        $(theForm).parent().find('.screen-reader-response').addClass('screen-reader-response-show');
        $(theForm).parent().find('.screen-reader-response').attr('id', formId + "-sr-response");
        $(theForm).parent().find('.screen-reader-response').attr('tabindex', '-1');


        $(theForm).find('input.wpcf7-not-valid').each(function (index) {//

            var label = $(this).closest('label').find('.label-txt').text();
            var id = $(this).attr("id");
            var name = $(this).attr("name");

            $(this).closest('label').addClass("invalid")

            if (id == undefined) {

                $(this).attr("id", name + "_" + index + "_" + formId);

                id = $(this).attr("id");
            }

            // console.log ("label="+label + " id="+id + "  name="+name );
            setUpInvlidListLink(formId, label, name, id);
        }

        )

        //$(formId+"-sr-response").focus();
        $('#' + formId + "-sr-response").trigger('focus');
        //window.location.href = "#"+formId+"-sr-response";

    }



    function setUpInvlidListLink(formId, label, name, id) {
        //  console.log('setUpInvlidListLink was called');
        var formId = formId;
        var label = label;
        var name = name;
        var id = id;

        label = (label.substr(label.length - 1, 1) == "*") ? label.substring(0, label.length - 1) : label;

        $('#' + formId + ' .screen-reader-response li').each(

            function (index) {
                //console.log( $(this).attr('id') + " "+ name);

                var nameLength = name.length;
                var thisId = $(this).attr('id');
                var txt;
                var link;

                //console.log (thisId.substring( thisId.length - nameLength, thisId.length ) );
                if (thisId.substring(thisId.length - nameLength, thisId.length) == name) {

                    var link = $(this).find('a');
                    // console.log("link="+ link.length);

                    if (link.length) {

                        txt = label + " " + $(link).text()
                        $(link).text(txt);

                    } else {


                        txt = label + " " + $(this).text();
                        $(this).html('<a href="#' + id + '" >' + txt + '</a>');

                    }



                }

            }

        )

    }


});